export function updateFieldValueAggrid(gridApi, rowId, fieldName, value) {
    const node = gridApi.getRowNode(rowId);
    node.setDataValue(fieldName, value);
}


export function updateFieldInForm(form, fieldName, value, columnValue = 'columnValue') {
    form.group_fields.forEach(groupChildren => {
        groupChildren.fields.forEach(data => {
        if (data.field_name === fieldName) {
          data[columnValue] = value;
        }
      });
    });
  }

export function getFieldValueAggrid(form, fieldName) {
  let result = '';
  form.group_fields.forEach(results => {
    results.fields.forEach(data => {
      if (data.field_name === fieldName) {
        result = data['columnValue'];
      }
    });
  });
  return result;
}

export function toggleCustomGrid() {
  const button: any =  document.querySelector('.ag-side-button-button');
  if (button) {
    button.click();
  }
}